import pagination from "../static/pagination";

const moduleName = "settlementEdcGlobalModule";

const state = {
	// Api
	isFetching: false,
	isLoadMore: false,
	response: {},
	hasChange: false,
	pagination: pagination(),

	// ListOptions
	listProvider: [],
	listDisetorKeAkun: [],

	// Card
	displayCard: [],
	lastItemToView: {},
	endItemOfPage: {},

	// Data Settlement
	listOutlet: [],
	countData: 0,
	listPembayaran: [],
	listSettlementEdc: [],
	selectedPembayaran: [],

	// Export
	exporting: false,
	minimizedExport: false,
	exportProgress: {
		processed: 0,
		total: 0,
	},
	multipleExport: false,
	exportData: [],
	exportDataLength: 0,
};

export {state as default, moduleName};
